import * as React from 'react';
export const IcCattleList = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13 15a1 1 0 100 2 1 1 0 000-2zm0 4a1 1 0 100 2 1 1 0 000-2zm6 0h-3a1 1 0 100 2h3a1 1 0 000-2zm-.25-11h-.09C20.93 6.05 21 4.23 21 4a1 1 0 00-.62-.92 1 1 0 00-1.09.21 12.77 12.77 0 01-2.82 2A5.45 5.45 0 0013 4h-2a5.45 5.45 0 00-3.47 1.28 12.77 12.77 0 01-2.82-2 1 1 0 00-1.09-.21A1 1 0 003 4c0 .23.07 2.05 2.34 4h-.09A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5a2.16 2.16 0 00.88-.18c.08.58.18 1.12.3 1.67A24.54 24.54 0 017 18a3 3 0 003 3v-5a3 3 0 013-3h4.47c0-.18.07-.35.1-.51.12-.55.22-1.09.3-1.67.277.12.577.182.88.18h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zm.25 7h-3a1 1 0 100 2h3a1 1 0 000-2z'
      fill='currentColor'
    />
  </svg>
);
